/* eslint-disable complexity */
import mixpanel from "mixpanel-browser";
import { getAppFeatureProp } from "@/utilities/app-feature-util";
import getAppCustomEnv from "@/utilities/get-app-custom-env";
import vueStore from "@/store/index";
import isEmpty from "lodash/isEmpty";
import getPlatformConfig from "@/utilities/get-platform-config";

export const handleDisplayNavbar = () => {
  const platformConfig = vueStore.state.configModule.platformConfig;
  const config = getAppFeatureProp(platformConfig["cmsAppFeatures"], "app_dashboard");
  return config;
};

class LogEvent {
  initialized = false;

  async init(growthbookInstance = null) {
    try {
      // Check if MixPanel is enabled
      const platformConfig = await getPlatformConfig(window.location.hostname);

      const mixpanelConfigFromCms = getAppFeatureProp(platformConfig["cmsAppFeatures"], "mix_panel");
      const mixPanelConfigFromGrowthbook = growthbookInstance ? growthbookInstance.isOn("mixpanel") : false;

      // If CMS can be fetched, then we use from CMS , else we get from GB ( if avail)
      const enableMixPanel = !isEmpty(mixpanelConfigFromCms)
        ? mixpanelConfigFromCms.enabled
        : mixPanelConfigFromGrowthbook;

      if (enableMixPanel == false) {
        console.warn("MixPanel is not enabled");
        console.warn("MixPanel config from CMS", mixpanelConfigFromCms);
        console.warn("MixPanel config from Growthbook", mixPanelConfigFromGrowthbook);

        return;
      }

      // Check if MixPanel token is configured
      const appCustomEnv = await getAppCustomEnv();
      const token = appCustomEnv.VUE_TOKEN_MIXPANEL;

      if (!token) {
        throw new Error("No VUE_TOKEN_MIXPANEL provided in env.json");
      }

      // Initialize
      const isProd = appCustomEnv.VUE_APP_SLEEK_ENV === "production";
      const loadedFn = growthbookInstance
        ? (mixpanel) => {
            growthbookInstance.setAttributes({
              ...growthbookInstance.getAttributes(),
              id: mixpanel.get_distinct_id(),
            });
          }
        : () => {};

      mixpanel.init(token, {
        debug: !isProd,
        persistence: "localStorage",
        loaded: loadedFn,
      });

      this.initialized = true;
    } catch (e) {
      console.warn("Error while initializing MixPanel integration", e);
      this.initialized = false;
    }
  }

  handleWriteToMixpanel(name = "", values = {}, type = "track") {
    if (!this.initialized) {
      console.warn("MixPanel is not initialized. Please call init() first.");
      return;
    }
    try {
      switch (type) {
        case "track":
          mixpanel.track(name, values);
          break;
        case "alias":
          mixpanel.alias(values);
          break;
        case "identify":
          mixpanel.identify(values);
          break;
        case "register":
          mixpanel.register(values);
          break;
        case "set":
          if (name) {
            mixpanel.people.set(name, values);
          } else {
            mixpanel.people.set(values);
          }
          break;
      }
    } catch (e) {
      console.error("Error while sending event to MixPanel", e);
    }
  }
}

export const logEvent = new LogEvent();
